












import { Vue, Prop, Component } from 'vue-property-decorator';

import TeamLogo from '@/components/common/team-logo/TeamLogo.vue';

@Component({
  components: { TeamLogo }
})
export default class WinnerCard extends Vue {
  @Prop({ default: false }) private isWinner!: boolean;
  @Prop({ default: { name: '' } }) private winner!: any;
  @Prop({ default: false }) private showCategory!: boolean;

  get isGrouped(): boolean {
    return !!(this.winner && this.winner.players && this.winner.players.length);
  }
}
